import { useState } from 'react';

type ToastType = 'success' | 'error' | 'info';

interface ToastMessage {
  title: string;
  message: string;
  type: ToastType;
}

export function useToast() {
  const [toast, setToast] = useState<ToastMessage | null>(null);

  const show = ({ title, message, type = 'info' }: ToastMessage) => {
    setToast({ title, message, type });
    // Auto hide after 3 seconds
    setTimeout(() => {
      setToast(null);
    }, 3000);
  };

  const hide = () => {
    setToast(null);
  };

  return {
    toast,
    show,
    hide
  };
} 